import { productCategoryIdFormat } from "@redotech/redo-ids-cockroach";
import { ProductCategorySourceSchema } from "@redotech/redo-model/inventory/product-category";
import { RedoFinderLoadTypeSchema } from "@redotech/redo-storefront-common/redo-finder-load";
import * as z from "zod";

const ProductTaxonomyItemSchema_ = z.object({
  id: productCategoryIdFormat.schema,
  source: z.string(),
  sourceId: z.string(),
  name: z.string(),
  parentId: productCategoryIdFormat.schema.nullable(),
  hasChildren: z.boolean(),
});
export const ProductTaxonomyItemSchema: z.ZodType<ProductTaxonomyItem> =
  ProductTaxonomyItemSchema_;
export interface ProductTaxonomyItem extends z.infer<
  typeof ProductTaxonomyItemSchema_
> {}

const ParentProductTaxonomySchema_ = z.object({
  id: productCategoryIdFormat.schema,
  parentId: productCategoryIdFormat.schema.nullable(),
});
export const ParentProductTaxonomySchema: z.ZodType<ParentProductTaxonomy> =
  ParentProductTaxonomySchema_;
export interface ParentProductTaxonomy extends z.infer<
  typeof ParentProductTaxonomySchema_
> {}

export const getProductTaxonomy = {
  name: "getProductTaxonomy" as const,
  input: z.object({
    source: ProductCategorySourceSchema,
    id: productCategoryIdFormat.schema.optional(),
    loadType: RedoFinderLoadTypeSchema,
  }),
  output: z.object({
    path: z.array(
      z.object({
        parent: ParentProductTaxonomySchema.nullable(),
        children: z.array(ProductTaxonomyItemSchema),
      }),
    ),
  }),
};
